export default __webpack_public_path__ + "static/media/init_btns.dac0528b.PNG";